"use strict";

module.exports = '5.10.3'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/version.js
// module id = 1197
// module chunks = 0